import $ from "jquery";
import { showYesNoModal } from "../components/dynamic-imports";

const connectapp = (hostname, callback_uri) => {
  showYesNoModal({
    title: "Connect application",
    onClickYes: () => $("#connect-application").submit(),
    onClickNo: () => (window.location.href = callback_uri),
    hostname
  });
};

export default connectapp;
